import React, { useEffect, useState } from 'react';
import { connect } from 'react-redux';
import { Card } from 'reactstrap';
import LoadingOverlay from 'react-loading-overlay';
import Loader from 'react-loaders';
import GetFileListBySubCategoryService from '../../../../../../../../../../Service/DashboardServices/AssetGalleryServices/GetFileListBySubCategoryService';
import ImportedFilesAssets from './ImportedFilesAssets';

function GoogleDriveAssetsDetails(props) {
  const [allFileListOfAssets, setAllFileListOfAssets] = useState([]);
  const [loadScreen, setLoadScreen] = useState(false);

  const fetchImportedFiles = () => {
    setLoadScreen(true);
    const data = {
      integerId: props.storeOverview.integerID,
      assetCategory: 3,
      subCategoryId: '',
      assetIdentifier: '',
    };

    GetFileListBySubCategoryService(props.token, data).then((response) => {
      setLoadScreen(false);
      if (response) {
        setAllFileListOfAssets(response.fileList || []);
      } else {
        setAllFileListOfAssets([]);
      }
    });
  };

  useEffect(() => {
    fetchImportedFiles();
  }, [props.storeOverview.integerID, props.refreshKey]);

  return (
    <div>
      <LoadingOverlay
        active={loadScreen}
        styles={{
          overlay: (base) => ({
            ...base,
            background: '#f1f4f6',
            opacity: 1,
          }),
          content: (base) => ({
            ...base,
            color: '#000',
          }),
        }}
        spinner={<Loader active type="ball-pulse" />}
        text="Loading imported files..."
      >
        <Card className="p-3 child-card">
          <ImportedFilesAssets
            allFileListOfAssets={allFileListOfAssets}
            setAllFileListOfAssets={setAllFileListOfAssets}
            assetCategory={3}
            onRefresh={fetchImportedFiles}
          />
        </Card>
      </LoadingOverlay>
    </div>
  );
}

const mapStateToProps = (state) => ({
  token: state.loggedUser.token,
  storeOverview: state.accountOverview.store.storeOverview,
});

export default connect(mapStateToProps)(GoogleDriveAssetsDetails);
